const Summary = () => {
  return (
    <p className='text-gray-500 max-w-md py-6 px-6 md:px-0'>
      {new Date().getFullYear() - 2022} years experienced Frontend Developer adept in React, Next.js, Tailwind CSS, and TypeScript. Expertise in crafting responsive and dynamic user interfaces.
      Passionate about delivering exceptional user experiences through intuitive web applications.
    </p>
  );
};

export default Summary;
